"use strict";
// Thin async-import entry that defers the actual render (and its
// synchronous `import "react"`) until Module Federation's shared-
// dependency negotiation completes. Without this indirection webpack
// throws "Shared module is not available for eager consumption" at
// runtime because `shared: { react: { singleton: true } }` in
// webpack.config.cjs uses non-eager loading by default.
import("./bootstrap");
